<article>
    <ng-container *ngIf="(isLoading$ | async) as Products; else loading">
        <ng-container *ngIf="Products.success; else error">
            <div class="--header__modules">
                <h1>Todos los productos</h1>
                <a [routerLink]="'/'+dashboard" class="btn">
                    <small class="-link"> Ver menos <mat-icon>keyboard_arrow_left</mat-icon></small>
                </a>
            </div>
            <div class="row" *ngFor="let categorias of this.appStateService.ProductByCategoriesRes.categories">
                <ng-container *ngIf="validateCategories(categorias.products)">
                    <h2>{{categorias.name}}</h2>
                    <app-layout-products [Products]="appStateService.ProductByCategoriesRes.categories[categorias.id].products" [Props]="{
                        styles: {
                            'grid-template-columns': 'repeat(auto-fill, minmax('+calc+', 1fr))',
                            'grid-gap': '20px 10px'
                        }
                    }"></app-layout-products>
                </ng-container>
            </div>
        </ng-container>
        <ng-template #error>
            <h1>Error</h1>
        </ng-template>

    </ng-container>
    <ng-template #loading>
        <ng-container *ngFor="let item of [0,1,2,3]">
            <h1>
                <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                    'width': '30%',
                    'margin': '20px 20px 0',
                    'border-radius': '4px',
                    'height': '30px',
                    'background-color': 'rgba(184, 184, 184, 0.2)'
                    }">
                </ngx-skeleton-loader>
            </h1>
            <app-layout-products></app-layout-products>
        </ng-container>
    </ng-template>
</article>